import { Typography } from "antd";
import React, { FC } from "react";
import { IJob } from "./helper";

interface Props {
  job?: IJob;
}
export const PageHeading: FC<Props> = ({ job }) => (
  <Typography.Title 
    level={2} 
    style={{ 
      fontSize: '36px',
      fontWeight: 700,
      color: '#2f54eb',
      letterSpacing: 1,
      marginBottom: 32,
      textAlign: 'center'
    }}
  >
    {job?.positionTitle || "Candidate Submission"}
  </Typography.Title>
);

export default PageHeading;